/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import {
  editBeneficiary,
  resetEditBeneficiary,
} from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";

import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  beneLookUp,
  resetBeneData,
  verifyThisPAN,
  viewAccountDetail,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import GSTVerification from "../../../Settings/GSTDetails";
import FieldForcePanDetails from "../FieldForcePanDetails";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const FieldForceEditPan = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [showAction, setShowAction] = useState(false);
  const [test, setTest] = useState(true);
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [alreadyLinked, setAlreadyLinked] = useState(false);
  const [nonArchive, setNonArchive] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [accountType, setAccountType] = useState({ type: "", id: "" });
  const [lookupNext, setLookupNext] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [shutViewAll, setShutViewAll] = useState(false);
  const [isAchived, setIsArchived] = useState(false);
  const [isBlock, setIsBlock] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isDennied, setIsDennied] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [newMessage, setNewMessage] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [hideCreate, setHideCreate] = useState(false);
  const [hideBlock, setHideBlock] = useState(false);
  const [previousBankNo, setPreviousBankNo] = useState("");
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [showAccInfo, setShowAccInfo] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    newGstValue: "",
  });
  const { beneVerifyGST } = useSelector((state) => state.beneAllVerification);
  const [updatedGst, setUpdatedGst] = useState({
    id: "",
    panNo: "",
    gstNo: "",
  });
  const [associatedPan, setAssociatedPan] = useState(true);

  const [GSTPanExist, setGSTPanExist] = useState(false);
  const [openPopEditCheck, setOpenPopEditCheck] = useState(false);
  const closeGSTDetailsModal = () => {
    setShowPopup(false);
  };
  const {
    verifyPAN,
    beneLookData,
    beneLookLoading,
    verifyPANisLoading,
    viewAccountDetailData,
    beneLookError,
    viewAccountDetailLoading,
  } = useSelector((state) => state.verify);
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const specialRegex = /^[a-zA-Z0-9 ]*$/;

  const [allData, setAllData] = useState([]);
  const [page, setPage] = useState(1);

  const { editBeneficiaryData } = useSelector(
    (state) => state.beneCreateAccount,
  );

  useEffect(() => {
    if (!verifyPANisLoading) {
      if (verifyPAN?.status === true) {
        setVerifiedPan(true);

        if (services?.includes("BUAccount") || services?.includes("Admin")) {
          dispatch(beneLookUp({ pan_number: payload.panNumber }));
        } else {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "BUAccount" },
          });
        }

        setPayload({
          ...payload,
          legalName: verifyPAN?.pan_details?.full_name,
        });
      } else if (verifyPAN?.status === false) {
        setVerifiedPan(false);
        setPayload({
          ...payload,
          gstin: "",
        });
        CommonToast({
          text: verifyPAN?.errors?.base?.[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  }, [verifyPAN]);

  useEffect(() => {
    let gstStoredData = sessionStorage.getItem("PAN GST Edit NewValue");
    if (!beneLookLoading && beneLookData?.status) {
      if (allData?.length === GlobalConfiguration.lengthCheckZero) {
        setAllData((allData) => [
          ...allData,
          ...beneLookData?.beneficiary_accounts,
        ]);

        if (services?.includes("BUAccount") || services?.includes("Admin")) {
          dispatch(beneLookUp({ pan_number: payload.panNumber, page: page }));
        } else {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "BUAccount" },
          });
        }

        if (beneLookData?.title?.records > allData?.length) {
          setTest(false);
        } else {
          setTest(true);
        }
      } else if (beneLookData?.title?.records > allData?.length) {
        setAllData((allData) => [
          ...allData,
          ...beneLookData?.beneficiary_accounts,
        ]);

        if (services?.includes("BUAccount") || services?.includes("Admin")) {
          dispatch(beneLookUp({ pan_number: payload.panNumber, page: page }));
        } else {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "BUAccount" },
          });
        }

        setPage((prevPage) => prevPage + 1);
        setTest(false);
      }
      allData?.forEach((val) => {
        if (val?.id === id) {
          setPayload({
            ...payload,
            gstin:
              gstStoredData != null ? gstStoredData : val?.gstin_detail || "",
          });
        }
      });
    }

    if (
      allData &&
      !beneLookLoading &&
      allData?.length === beneLookData?.title?.records
    ) {
      const hasId = allData.some((val) => val?.id === id);
      setAssociatedPan(hasId);
    } else if (!beneLookLoading && beneLookError && !allData) {
      BenEnableNextButton(false);
      setAssociatedPan(false);
    }

    if (haveLinkNew && !beneLookLoading) {
      setIsLinkedAccount(true);
    } else if (
      haveLinkNew === undefined ||
      (haveLinkNew === false && !beneLookLoading)
    ) {
      setNewMessage(false);
    }
  }, [beneLookData, id, beneLookError]);

  const handleNext = () => {};

  const handleBack = () => {
    if (nextButtonEnabled && !openPopEditCheck) {
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
      );
    } else if (openPopEditCheck) {
      setOpenPopEdit(true);
    } else {
      setOpenPopEdit(true);
    }
  };

  useEffect(() => {
    const fetchPANData = async () => {
      let response = await dispatch(viewAccountDetail({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANData();
  }, [dispatch, id, navigate]);

  let haveLinkNew = allData?.some((val) => {
    return val?.bank_acc_no === previousBankNo && val?.id !== id;
  });

  useEffect(() => {
    sessionStorage.setItem("Pan Gst Verification", JSON.stringify(updatedGst));
  }, [updatedGst]);

  useEffect(() => {
    setIsFocus(true);
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      setUpdatedGst({
        id: viewAccountDetailData?.beneficiary_accounts[0]?.id,
        panNo: viewAccountDetailData?.beneficiary_accounts[0]?.pan_no,
        gstNo: viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail,
      });
      setPayload({
        ...payload,
        panNumber: viewAccountDetailData?.beneficiary_accounts[0]?.pan_no,
        gstin: viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail,
      });

      if (services?.includes("BUAccount") || services?.includes("Admin")) {
        dispatch(
          verifyThisPAN({
            pan_number: viewAccountDetailData?.beneficiary_accounts[0]?.pan_no,
            navigate: navigate,
          }),
        );
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [viewAccountDetailData]);

  const shouldNextBtnBeEnabled =
    (isLinkedAccount || alreadyLinked) && verifiedPan
      ? nextButtonEnabled
      : !nextButtonEnabled;
  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "PAN details, GSTIN",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled: shouldNextBtnBeEnabled,
      nextHoverOption: "black",
    },
  ];

  const handleUpdateAccount = () => {
    dispatch(
      editBeneficiary({
        id: id,
        pan: payload.panNumber,
        name: payload?.legalName,
        gstin: payload?.gstin,
        navigate,
      }),
    );
    setAccountType({ type: "", id: "" });
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
  };

  useEffect(() => {
    if (editBeneficiaryData?.status === true) {
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details_success/${id}`,
      );
      localStorage.setItem("haveAssociated", JSON.stringify(beneLookError));
      dispatch(resetEditBeneficiary());
    }
  }, [editBeneficiaryData]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.id === id) {
        setGSTPanExist(val?.gstin_detail ? true : false);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const handlePanChange = (e) => {
    const inputPan = e.target.value.toUpperCase();

    if (inputPan?.length < GlobalConfiguration.panLength) {
      setOpenPopEditCheck(true);
    }
    if (panRegex.test(inputPan)) {
      setOpenPopEditCheck(true);
    }
    if (viewAccountDetailData?.beneficiary_accounts[0]?.pan_no === inputPan) {
      setOpenPopEditCheck(false);
    }

    if (!specialRegex.test(inputPan)) {
      return;
    }

    if (inputPan?.length > GlobalConfiguration.panLength) {
      return;
    }
    if (
      !panRegex.test(inputPan) &&
      inputPan?.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetBeneData());
      setPayload({
        ...payload,
        gstin: "",
      });
    } else if (inputPan?.length === GlobalConfiguration.panLength) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
        dispatch(verifyThisPAN({ pan_number: inputPan, navigate: navigate }));
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }

      setAllData([]);
    } else {
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
      setAccountType({ type: "", id: "" });

      setShowAccInfo(false);
      sessionStorage.removeItem("PAN GST Edit NewValue");
    }

    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: "",
    });
    setAccountType({ type: "", id: "" });
    setIsLinkedAccount(false);
    setNewMessage(false);
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setShowAction(false);
    setIsBlock(false);
    setDisableCreateNext(false);
    setIsActive(false);
    setHideBlock(false);
    setHideCreate(false);
    setNonArchive(false);
    setAlreadyLinked(false);
  };

  const handleConfirm = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };

  return (
    <div
      className="edit_bank_con_main !h-screen"
      style={{
        overflowY: false ? "hidden" : "hidden",
        height:
          achivedOpenPop || unachivedOpenPop || showRejectTnxPopup
            ? "var(--full-height)"
            : "",
      }}
    >
      {openPopEdit && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Are you sure you want to leave this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenPopEdit(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center  Qmd:bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal">
          <LargePopupRedirect
            headerTitle="GST Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate("/settings/GST_verification", {
                state: beneVerifyGST?.gstin_details?.gstin_no,
              })
            }
            closeiconhandleFunction={() => setShowPopup(false)}
          >
            <GSTVerification
              gst_number={beneVerifyGST?.gstin_details?.gstin_no}
              closeGSTDetailsModal={closeGSTDetailsModal}
              popup={true}
              setShowPopup={setShowPopup}
              showPopup={showPopup}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div className="w-full z-z-index-base relative flex-col justify-center items-center Qsmd:flex hidden">
        <div className="h-navbar-breadcrumb-height" />
        <div className="w-full Qlg:w-std-width relative min-h-stepper-height">
          <PrimaryStepper
            activeStep={0}
            handleForwardAction={handleUpdateAccount}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
      </div>

      {/* <div className="Qsmd:h-navbar-breadcrumb-height min-h-[var(--navbar-height)]"></div> */}
      <div className="top_bar_btn_resp_edit_ff Qsmd:hidden flex">
        <TopNavComponent
          isFormattingNotRequired
          topNavHeader={"Field force account"}
          topNavSubText="PAN details, GSTIN"
          handleBack={handleBack}
        />
        <div
          className={`h-mobile-create-header ${
            shouldNextBtnBeEnabled
              ? "bg-positive-act cursor-pointer"
              : "bg-text-disabled cursor-not-allowed"
          } fixed bottom-bottom-base w-width-full text-text-primary items-center justify-center flex font-semibold z-z-index-modal Qsmd:hidden`}
          onClick={shouldNextBtnBeEnabled ? handleUpdateAccount : undefined}
        >
          Update
        </div>
      </div>
      <div className="h-navbar-height block Qsmd:hidden flex-shrink-0 flex-grow-0"></div>
      <div className="w-full overflow-auto pb-padding-lg Qsmd:pb-padding-base">
        <div className="z-z-index-base relative">
          <div className="Qsmd:p-padding-md p-padding-sm"></div>
          <FieldForcePanDetails
            showPopup={showPopup}
            setShowPopup={setShowPopup}
            showAccInfo={showAccInfo}
            allData={allData}
            setShowAccInfo={setShowAccInfo}
            associatedPan={associatedPan}
            test={test}
            gstin={payload?.gstin}
            panNumber={payload.panNumber}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
            panDetails={verifyPAN?.pan_details}
            beneLookData={beneLookData}
            beneLookLoading={beneLookLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={verifyPANisLoading}
            isAchived={isAchived}
            setIsArchived={setIsArchived}
            setIsApproved={setIsApproved}
            isApproved={isApproved}
            handleNext={handleNext}
            accountType={accountType}
            setAccountType={setAccountType}
            isDennied={isDennied}
            setIsDennied={setIsDennied}
            setIsPending={setIsPending}
            isPending={isPending}
            nextButtonEnabled={nextButtonEnabled}
            shutViewAll={shutViewAll}
            setShutViewAll={setShutViewAll}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            panLatestData={payload.panNumber}
            isFocus={isFocus}
            setIsFocus={setIsFocus}
            type={"editFlow"}
            showAction={showAction}
            setShowAction={setShowAction}
            previousId={id}
            setIsBlock={setIsBlock}
            isBlock={isBlock}
            isActive={isActive}
            setIsActive={setIsActive}
            setNewMessage={setNewMessage}
            newMessage={newMessage}
            beneLookError={beneLookError}
            setHideBlock={setHideBlock}
            setHideCreate={setHideCreate}
            hideBlock={hideBlock}
            hideCreate={hideCreate}
            setNonArchive={setNonArchive}
            nonArchive={nonArchive}
            previousBankNo={previousBankNo}
            setPreviousBankNo={setPreviousBankNo}
            isLinkedAccount={isLinkedAccount}
            setIsLinkedAccount={setIsLinkedAccount}
            unachivedOpenPop={unachivedOpenPop}
            setUnachivedOpenPop={setUnachivedOpenPop}
            achivedOpenPop={achivedOpenPop}
            setAchivedOpenPop={setAchivedOpenPop}
            alreadyLinked={alreadyLinked}
            setAlreadyLinked={setAlreadyLinked}
            haveLinkNew={haveLinkNew}
            setPayload={setPayload}
            payload={payload}
            setGSTPanExist={setGSTPanExist}
            GSTPanExist={GSTPanExist}
            showRejectTnxPopup={showRejectTnxPopup}
            setRejectTxnPopup={setRejectTxnPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default FieldForceEditPan;
